import { FT } from 'ft'
import { Sprite, BLEND_MODES } from 'pixi.js'

const { rm, res } = FT

class Quilt extends Sprite {
  constructor(isRewarded, quiltId, level) {
    super()

    const quiltTextureName = isRewarded
      ? `bed-quilt${quiltId}-empty`
      : `bed-quilt${quiltId}`
    this.texture = rm.texture(quiltTextureName)
    this.anchor.set(0.5, 1)
    this.position.set(FT.stage.centerX, FT.stage.height - 10)

    if (isRewarded) {
      const slogan = new Sprite(rm.texture(`bed-quilt${quiltId}-slogan`))
      slogan.anchor.set(1, 0)
      slogan.blendMode = BLEND_MODES.MULTIPLY
      slogan.position.set(FT.stage.bounds.width / 2 - 5, -764)
      this.addChild(slogan)

      let welcomeURL
      if (level >= 1 && level <= 7) {
        welcomeURL = res.url(`bed-welcome.quilt${quiltId}-level${level}`)
      } else {
        welcomeURL = res.url(`bed-welcome.quilt${quiltId}`)
      }
      const welcome = Sprite.from(welcomeURL)
      welcome.anchor.set(0.5, 0)
      this.addChild(welcome)

      switch (quiltId) {
        case 1:
          welcome.position.set(0, -574)
          break
        case 2:
          welcome.position.set(0, -578)
          break
        case 3:
          welcome.position.set(-180, -546)
          break
      }
    }
  }
}

export default Quilt
